import { render, staticRenderFns } from "./HeaderAlerts.vue?vue&type=template&id=9d3603be&scoped=true"
import script from "./HeaderAlerts.vue?vue&type=script&lang=js"
export * from "./HeaderAlerts.vue?vue&type=script&lang=js"
import style0 from "./HeaderAlerts.vue?vue&type=style&index=0&id=9d3603be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3603be",
  null
  
)

export default component.exports